import React, {useRef} from "react";
import UpdateFile from "../files/UpdateFile";
import AttachmentFileList from "../files/AttachmentFileList";
import AttachmentListUploader from "../files/AttachmentListUploader";
import {AttachmentContainer, AttachmentLane} from "../files/AttachmentContainer";
import {appendDocFiles} from "../files/createAttachHelpers";

function resolveLaneLabel(label, title) {
    if (label) return label;
    if (title && title !== "첨부") return title;
    return "파일";
}

export function DetailAttachFileContent({isEditing, tableInfo, label, title}) {
    const laneLabel = resolveLaneLabel(label, title);

    return (
        <AttachmentLane label={laneLabel} variant="file">
            <UpdateFile
                readOnly={!isEditing}
                displayMode="list"
                className="update-image"
                tableInfo={tableInfo}
            />
        </AttachmentLane>
    );
}

export function DetailPendingAttachFileContent({
    pendingFiles,
    inputId = "detail_pending_doc",
    label,
    title,
}) {
    const {files, setFiles} = pendingFiles;
    const docIdRef = useRef(0);
    const laneLabel = resolveLaneLabel(label, title);

    const listItems = files.map((f) => ({
        id: f.id,
        originalName: f.originalName || f.object?.name || "파일",
    }));

    const handleInputChange = (e) => {
        setFiles((prev) => appendDocFiles(prev, e.target.files, docIdRef));
        e.target.value = "";
    };

    return (
        <AttachmentLane label={laneLabel} variant="file" count={listItems.length}>
            <AttachmentListUploader
                inputId={inputId}
                onInputChange={handleInputChange}
                hasFiles={listItems.length > 0}
                fileList={
                    <AttachmentFileList
                        items={listItems}
                        onRemove={(item) => setFiles((prev) => prev.filter((f) => f.id !== item.id))}
                    />
                }
            />
        </AttachmentLane>
    );
}

export function DetailFilePanel({
    label,
    title,
    isEditing,
    tableInfo,
    pendingFiles,
    pendingInputId,
    className = "",
}) {
    return (
        <AttachmentContainer className={className}>
            {pendingFiles ? (
                <DetailPendingAttachFileContent
                    pendingFiles={pendingFiles}
                    inputId={pendingInputId}
                    label={label}
                    title={title}
                />
            ) : (
                <DetailAttachFileContent
                    isEditing={isEditing}
                    tableInfo={tableInfo}
                    label={label}
                    title={title}
                />
            )}
        </AttachmentContainer>
    );
}
